// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".infopanelPopoverContent_root__2W5lu {\n  width: 100%;\n  height: 130px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column; }\n  .infopanelPopoverContent_root__2W5lu .infopanelPopoverContent_title__3Dsdn {\n    font-size: 12px;\n    font-weight: bold;\n    margin-bottom: 10px; }\n", ""]);
// Exports
exports.locals = {
	"root": "infopanelPopoverContent_root__2W5lu",
	"title": "infopanelPopoverContent_title__3Dsdn"
};
module.exports = exports;
